import type { ChatEvent } from 'ts-components/PiChat/chatEvents';

export interface RestoreEvent extends ChatEvent {
  direction: 'undo' | 'redo';
  version: number; // 1-based position of the restored snapshot
}

export const toRestoreEvent = ({
  id,
  snapshotIds,
  previousPointer,
  restoredSnapshotId,
  afterCount,
}: {
  id: string;
  snapshotIds: string[];
  previousPointer: number;
  restoredSnapshotId: string;
  afterCount: number;
}): RestoreEvent | null => {
  const index = snapshotIds.indexOf(restoredSnapshotId);
  if (index === -1) return null;
  return {
    id,
    afterCount,
    direction: index < previousPointer ? 'undo' : 'redo',
    version: index + 1,
  };
};

export interface RestoreEventsState {
  events: RestoreEvent[];
  nextId: number;
}

export type RestoreEventsAction =
  | {
      type: 'restored';
      snapshotIds: string[];
      previousPointer: number;
      restoredSnapshotId: string;
      afterCount: number;
    }
  | { type: 'connecting' };

export const INITIAL_RESTORE_EVENTS: RestoreEventsState = {
  events: [],
  nextId: 1,
};

export const restoreEventsReducer = (
  state: RestoreEventsState,
  action: RestoreEventsAction
): RestoreEventsState => {
  switch (action.type) {
    case 'restored': {
      const { type: _type, ...args } = action;
      const event = toRestoreEvent({ ...args, id: `restore-${state.nextId}` });
      return event
        ? { events: [...state.events, event], nextId: state.nextId + 1 }
        : state;
    }
    case 'connecting':
      return state.events.length ? { ...state, events: [] } : state;
    default:
      return state;
  }
};
